import React, { Component } from 'react';
import { Checkbox } from 'antd';
import EditableCell from '../../../../basicElement/EditableCell';
import TableC from '../../../../basicElement/TableC';
import format from '../../../../shared/format';

class Summary extends Component {
    state = {
        needDiscount: false,
    }

    handleCheckChange = e => {
        this.setState({ needDiscount: e.target.checked });
    }

    getTabelCell = (key, index, amount, colSpan) => {
        const { names, editable, onChange } = this.props;
        const value = this.props[key];
        const { needDiscount } = this.state;
        return {
            children: (
                <div>
                    {
                        editable &&
                        <div className="inlineBlock" style={{width: '50%'}}>
                            <EditableCell
                                type="Number"
                                editable={editable}
                                value={value}
                                disabled={key !== 'discount' ? false : !needDiscount}
                                style={{ width: '87%' }}
                                placeholder={names.inputPlaceholder}
                                config={{max: 100, precision: 2}}
                                onChange={value => onChange(value, index, key)}
                            />
                            <span style={{margin: '0 10px 0 4px'}}>%</span>
                        </div>
                    }
                    { (amount || amount === 0) && (editable ? `(${format('money', amount)})` : format('money', amount)) }
                </div>
            ),
            props: { colSpan },
        };
    }

    getAmountA = () => {
        const { data, names, showIaIb } = this.props;
        const len = data.length;
        const width = showIaIb ? 200 : 400;
        const colSpan = showIaIb ? 2 : 1;
        return {
            title: `${names.amount}${showIaIb ? '(Ia期)' : ''}`,
            dataIndex: 'amountA',
            key: 'amountA',
            width: width,
            render: (text, record, index) => {
                const { amount } = record;
                if (index === len - 1) {
                    return {
                        children: <strong>{format('money', amount)}</strong>,
                        props: { colSpan },
                    };
                } else if (index === len - 2) {
                    return this.getTabelCell('tax', index, amount, colSpan);
                } else if (index === len - 3) {
                    return this.getTabelCell('discount', index, amount, colSpan);;
                } else if (index === len - 4) {
                    return <strong>{format('money', text)}</strong>;
                } else {
                    return format('money', text);
                }
            },
        };
    }

    getColumns = () => {
        const { data, editable, discount, tax, names, showIaIb } = this.props;
        const { needDiscount } = this.state;

        const len = data.length;
        const columns = [{
            title: names.num,
            dataIndex: 'num',
            key: 'num',
            width: 100,
        }, {
            title: names.projectName,
            dataIndex: 'projectName',
            key: 'projectName',
            render: (text, record, index) => {
                if (index === len - 1) {
                    return <strong>{text}</strong>;
                } else if (index === len - 2) {
                    return (
                        <div>
                            {text}
                            {editable ? `(${names.discountTotalAmountPer})` : `(${discount}%)`}
                        </div>
                    );
                } else if (index === len - 3) {
                    return (
                        <div>
                            {text}
                            {editable ? `(${names.totalAmountPer})` : `(${tax}%)`}
                            {
                                editable &&
                                <Checkbox
                                    checked={needDiscount}
                                    style={{ marginLeft: 30 }}
                                    onChange={this.handleCheckChange}
                                >{names.discount}</Checkbox>
                            }
                        </div>
                    );
                } else if (index === len - 4) {
                    return <strong>{text}</strong>;
                } else {
                    return text;
                }
            },
        }];
        columns.push(this.getAmountA());
        if (showIaIb) {
            columns.push({
                title: `${names.amount}${showIaIb ? '(Ib期)' : ''}`,
                dataIndex: 'amountB',
                key: 'amountB',
                width: 200,
                render: (text, record, index) => {
                    if (index > len - 4) {
                        return {
                            children: null,
                            props: {
                                colSpan: 0,
                            },
                        };
                    } else if (index === len - 4) {
                        return <strong>{format('money', text)}</strong>;
                    } else {
                        return format('money', text);
                    }
                },
            });
        }
        columns.push({
            title: names.expenseProportion,
            dataIndex: 'expenseProportion',
            key: 'expenseProportion',
            width: 200,
        });
        return columns;
    }

    render() {
        const { data } = this.props;
        return (
            <TableC
                data={data}
                columns={this.getColumns()}
                className="quotation_summary"
            />
        );
    }
}

export default Summary;


// WEBPACK FOOTER //
// ./src/components/quotation/Production/Total/Table/Summary.js